import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }
  static getDerivedStateFromError() {
    return { error: true };
  }
  componentDidCatch(err) {
    console.error(err);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ivory px-6">
          <div className="text-center max-w-md">
            <span className="inline-block w-2.5 h-2.5 rounded-full bg-enji mb-6" />
            <h1 className="font-serif text-3xl text-ink">Ada yang tidak beres</h1>
            <p className="text-sub mt-3">Muat ulang halaman untuk mencoba lagi.</p>
            <button onClick={() => window.location.reload()} className="btn-primary mt-8">
              Muat Ulang
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

